export default {
  en: {
    actions: {
      mute: 'Mute',
      unmute: 'Unmute',
      exit: 'Exit chat',
      mark_all_as_read: 'Mark all as read',
      see_members: 'See members',
      back_to_group: 'Back to group',
    },
  },
};
